export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = 273
// module chunks = 0